import * as Yup from 'yup';

export const BundlePriceSchema = Yup.object().shape({
    numberOfLookups: Yup.string()
        .required('Number of lookups is required')
        .test('is-positive-integer', 'Number of lookups must be a positive whole number', (value) => {
            if (!value) return false;
            const n = Number(value.trim());
            return !Number.isNaN(n) && n > 0 && Number.isInteger(n);
        }),
    originalPrice: Yup.string()
        .required('Original price is required')
        .test('is-positive-number', 'Original price must be greater than ₦0', (value) => {
            if (!value) return false;
            const n = Number(value.toString().replace(/,/g, '').trim());
            return !Number.isNaN(n) && n > 0;
        }),
    discount: Yup.string()
        .required('Discount is required')
        .test('is-valid-discount', 'Discount must be between 0 and 100', (value) => {
            if (value === undefined || value === null || value === '') return false;
            const n = Number(value.toString().replace(/,/g, '').trim());
            return !Number.isNaN(n) && n >= 0 && n <= 100;
        }),
    newPrice: Yup.string()
        .required('New price is required')
        .test('is-non-negative-number', 'New price must be a valid amount', (value) => {
            if (value === undefined || value === null || value === '') return false;
            const n = Number(value.toString().replace(/,/g, '').trim());
            return !Number.isNaN(n) && n >= 0;
        }),
});

export type BundlePriceDataType = Yup.InferType<typeof BundlePriceSchema>;

type InitialValues = {
    numberOfLookups: string;
    originalPrice: string;
    newPrice: string;
    discount: string;
};


export const BundlePriceInitialValues: InitialValues = {
    numberOfLookups: '',
    originalPrice: '',
    newPrice: '',
    discount: '',
};

export interface BundlePriceInterface {
    numberOfLookups: string;
    originalPrice: string;
    newPrice: string;
    discount: string;
}
